// removed by extract-text-webpack-plugin
module.exports = {"appHeader":"_-src-components-Section-index---appHeader---15Y7y","title":"_-src-components-Section-index---title---30JKI","loader":"_-src-components-Section-index---loader---1_ftm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/index.css
// module id = 738
// module chunks = 1